import { User } from 'oidc-client';
import { createContext } from 'react';

const UserDetailsContext = createContext<{ user: User | null }>({ user: null });

export default UserDetailsContext;
